import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal, Button } from 'react-bootstrap';
import FlexRow from 'templates/FlexRowTemplate';
import './style.scss';

const StyledTitle = styled.h3`
  color: ${({ variant, theme }) => {
    if (variant === 'success') return theme.dillakGreen;
    if (variant === 'danger') return theme.dillakDanger;
  }};
`;

const ModalContainer = props => {
  const {
    title = '',
    closeModal,
    children,
    footer = null,
    variant = 'success',
    size = 'xs',
    onHide = null,
    onOk = () => {},
    disabled = false,
    style = {},
    ...rest
  } = props;
  return (
    <div>
      <Modal
        show
        onHide={onHide || closeModal}
        size={size}
        style={style}
        {...rest}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <StyledTitle variant={variant}>{title}</StyledTitle>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {children}
          <hr />
          <FlexRow justify="flex-end">
            {footer || (
              <>
                <Button variant="success" onClick={onOk} disabled={disabled}>
                  Zatwierdź
                </Button>
                <Button variant="danger" onClick={closeModal}>
                  Anuluj
                </Button>
              </>
            )}
          </FlexRow>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ModalContainer;
